import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes, FaUser, FaCamera } from 'react-icons/fa';

const EditUserModal = ({ isOpen, onClose, onSubmit, user }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    role: '',
    email: '',
    phone: '',
    status: true,
    avatar: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        role: user.role || '',
        email: user.email || '',
        phone: user.phone || '',
        status: user.status === 'Active',
        avatar: user.avatar || ''
      });
    }
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData(prev => ({ ...prev, avatar: reader.result }));
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{t('admin.user_management.edit_user')}</h2>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="image-upload">
          <div className="upload-placeholder">
            {formData.avatar ? (
              <img
                src={formData.avatar}
                alt="avatar"
                className="avatar-preview"
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '2px solid #ddd'
                }}
              />
            ) : (
              <FaUser style={{ fontSize: '48px', color: '#9ca3af' }} />
            )}
          </div>
          <label className="upload-btn">
            <FaCamera style={{ marginRight: 6 }} />
            {t('admin.user_management.change_image')}
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              hidden
            />
          </label>
          <p className="upload-info">{t('admin.user_management.image_info')}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label required">{t('admin.user_management.user_name')}</label>
            <input
              type="text"
              name="name"
              className="form-input"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label required">{t('admin.user_management.role')}</label>
            <select
              name="role"
              className="form-select"
              value={formData.role}
              onChange={handleInputChange}
              required
            >
              <option value="">{t('admin.user_management.select_role')}</option>
              <option value="ADMIN">ADMIN</option>
              <option value="USER">USER</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label required">{t('admin.user_management.email')}</label>
            <input
              type="email"
              name="email"
              className="form-input"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label required">{t('admin.user_management.phone')}</label>
            <input
              type="tel"
              name="phone"
              className="form-input"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <div className="status-toggle">
              <span className="form-label">{t('admin.user_management.status')}</span>
              <div
                className="toggle-switch"
                onClick={() => setFormData(prev => ({ ...prev, status: !prev.status }))}
                style={{
                  width: '40px',
                  height: '20px',
                  borderRadius: '10px',
                  backgroundColor: formData.status ? '#16a34a' : '#d1d5db',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease'
                }}
              >
                <div
                  style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    backgroundColor: '#fff',
                    transform: formData.status ? 'translateX(20px)' : 'translateX(0)',
                    transition: 'transform 0.3s ease'
                  }}
                ></div>
              </div>
              <span style={{ marginLeft: 10 }}>
                {formData.status ? t('admin.user_management.active') : t('admin.user_management.inactive')}
              </span>
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              {t('admin.user_management.actions.cancel')}
            </button>
            <button type="submit" className="submit-btn">
              {t('admin.user_management.actions.update')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserModal;
